import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserDomain } from 'src/app/models/custom/userdomain';

@Component({
  selector: 'app-user-domain-list',
  templateUrl: './user-domain-list.component.html',
  styleUrls: ['./user-domain-list.component.scss']
})
export class UserDomainListComponent implements OnInit {

  @Output() selected: EventEmitter<UserDomain> = new EventEmitter();
  @Input() domains: UserDomain[] = [];
  public selectedDomain: UserDomain;

  constructor() { }

  ngOnInit(): void {
  }

  public select(domain: UserDomain) {
    this.selectedDomain = domain;
    this.selected.emit(domain);
  }

}
